module.exports = __webpack_public_path__ + "img/jr-td.0d661e18.jpg";